/**
 * Anvil-scoped debug switch. Lets a builder/dev raise Anvil log verbosity
 * (console + debugger DEBUG severity) WITHOUT flipping the global log level.
 * Backed by localStorage so it survives reloads; toggled via devtools or the
 * "Toggle Anvil debug logging" command-palette command.
 */
export const ANVIL_DEBUG_STORAGE_KEY = "anvil:debug";

const ON = "on";

export function isAnvilDebugEnabled(): boolean {
  try {
    return window.localStorage.getItem(ANVIL_DEBUG_STORAGE_KEY) === ON;
  } catch {
    // localStorage can throw (privacy mode / SSR); default to off.
    return false;
  }
}

export function setAnvilDebug(enabled: boolean): void {
  try {
    if (enabled) {
      window.localStorage.setItem(ANVIL_DEBUG_STORAGE_KEY, ON);
    } else {
      window.localStorage.removeItem(ANVIL_DEBUG_STORAGE_KEY);
    }
  } catch {
    // No-op if storage is unavailable.
  }
}
